module.exports = __webpack_public_path__ + "img/28.41efd468.png";